"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _Logo = _interopRequireDefault(require("./Logo"));
var _utils = require("@/utils");
var _SidebarItem = _interopRequireDefault(require("./SidebarItem"));
var _variables2 = _interopRequireDefault(require("@/styles/variables.scss"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    SidebarItem: _SidebarItem.default,
    Logo: _Logo.default
  },
  data: function data() {
    return {
      routes: [],
      appConfig: {}
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['permission_routes', 'sidebar'])), {}, {
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables2.default;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  created: function created() {
    var platform = parseInt(this.$store.state.app.curPlatform);
    this.routes = this.filterRoute(this.permission_routes, platform);
    this.initAppConfig();
  },
  methods: {
    // 初始化APP配置
    initAppConfig: function initAppConfig() {
      var _this = this;
      var appList = this.$store.state.app.appList;
      appList = (0, _utils.deepClone)(appList);
      appList.forEach(function (item) {
        _this.appConfig[item['pid']] = item['id'];
      });
    },
    // 判断是否有开发权限
    hasDevPermission: function hasDevPermission() {
      // 当前PID
      var pid = this.$store.state.app.curPid;
      // 当前所有的AP_routes
      var app_roles = this.$store.state.user.app_roles;
      if (parseInt(app_roles[this.appConfig[pid.toString()]]) === 3) return false;
      return true;
    },
    filterRoute: function filterRoute(routes, platform) {
      var _this2 = this;
      var accessedRoutes = [];
      routes.forEach(function (item) {
        if (item.name === 'Game') {
          if (_this2.hasDevPermission()) {
            accessedRoutes.push(item);
          }
        } else {
          if (item.meta && item.meta.onlyShow) {
            if (item.meta.onlyShow.includes(platform)) {
              accessedRoutes.push(item);
            }
          } else {
            accessedRoutes.push(item);
          }
        }
      });
      return accessedRoutes;
    }
  }
};
exports.default = _default;